import { render } from "./OfferSellerTooltip.vue?vue&type=template&id=66714eda"
import script from "./OfferSellerTooltip.vue?vue&type=script&lang=js"
export * from "./OfferSellerTooltip.vue?vue&type=script&lang=js"

import "./OfferSellerTooltip.vue?vue&type=style&index=0&id=66714eda&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/product/catalog/parts/OfferSellerTooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66714eda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66714eda', __exports__)) {
    api.reload('66714eda', __exports__)
  }
  
  module.hot.accept("./OfferSellerTooltip.vue?vue&type=template&id=66714eda", () => {
    api.rerender('66714eda', render)
  })

}


export default __exports__